import { jsxs as r, jsx as t } from "react/jsx-runtime";
import i from "react";
const d = i.memo(({
  size: o = "24px",
  ...e
}) => /* @__PURE__ */ r("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ t("path", { d: "M12 14V8", stroke: "#707485", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M12.5 18a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z", fill: "#707485", stroke: "#707485", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M9.353 2.692c1.177-2.256 4.117-2.256 5.293 0l7.94 15.231C23.762 20.18 22.292 23 19.94 23H4.06c-2.352 0-3.822-2.82-2.646-5.077l7.94-15.23z", stroke: "#707485", strokeWidth: "1.5" })
] }));
export {
  d as default
};
//# sourceMappingURL=WarningIcon.es.js.map
